import { apiFetch } from "../lib/auth";
import type { CandidateComp } from "./types";

export type ActivesOrder = "best" | "nearest";

export interface ActivesRank {
  /** Indices into the rows sent, best first. The client never ranks. */
  order: number[];
  /** One reason per row sent, same indexing. */
  reasons: string[];
  why: string;
}

/** The subject fields the engine's ranking reads, and nothing else. */
export interface RankSubject {
  gla?: number | null;
  lot_sf?: number | null;
  year?: number | null;
  subdivision?: string | null;
  condition_code?: string | null;
}

/** Ask the server for the competing homes' order. It reads only the rows sent: no MLS, no provider. */
export async function rankActives(subject: RankSubject, listings: CandidateComp[], order: ActivesOrder): Promise<ActivesRank> {
  return apiFetch<ActivesRank>("/api/next/actives/rank", { method: "POST", body: { subject, listings, order } });
}
